// src/utils/toolsConfig.js
import FastApiToolModal from "../components/FastApiToolModal";

export const TOOLS_LIST = [
  {
    id: "gis-vertex",
    title: "⚡ GIS Data Solutions Tool",
    description: "Click here to launch the interactive Transmission GIS Tools.",
    modalComponent: FastApiToolModal,
  }
];